<template>
    <div class="cart-options-section" :id="'cartOptions-' + itemIndex">
        <div v-if="!isPack" class="button-options" :class="{ 'single-option': singleOption}" >
            <OptionBtn
                v-if="showPrimaryButton"
                v-model="selectedOptions.primary"
                :label="primaryOptions.length && primaryOptions[0].label ? primaryOptions[0].label: kStrings.kGLOB_OPTION"
                :disabled="(primaryOptions && primaryOptions.length < 2) || lockButtons || outOfStockPack"
                :option="selectedOptions.primary && selectedOptions.primary.description ? selectedOptions.primary.description: ''"
                :option-list="primaryOptions"
                :default-value="selectedOptions.primary"
                :item-index="itemIndex"
                :show-stock-warning-labels="singleOption"
                class="primary-btn order-1"
                :class="{'no-sel-active' : emptySelectionWarning && !selectedOptions.primary}"
                :key="currentGroupId"
                @update-current-option="updateCurrentOption"
            />

            <OptionBtn
                v-if="showSecondaryButton"
                v-model="selectedOptions.secondary"
                :label="secondaryOptions.length && secondaryOptions[0].label"
                :disabled="(isPack && secondaryOptions.length < 2) || lockButtons || outOfStockPack"
                :option="selectedOptions.secondary ? selectedOptions.secondary.description : ''"
                :option-list="secondaryOptions"
                :default-value="!isPack ? selectedOptions.secondary : null"
                :item-index="itemIndex"
                :key="currentGroupId"
                class="secondary-btn order-0"
                :class="{'no-sel-active' : emptySelectionWarning}"
                selection-type="secondary"
                @update-current-option="updateCurrentOption"
            />

            <QuantityPicker
                v-if="showQty"
                v-model="currentQty"
                :label="showSoloQtyBtn || singleOption ? kStrings.kGLOB_QUANTITY : ''"
                :default-qty="cartItemQty"
                :item-index="itemIndex"
                :qty-limit="qtyLimit"
                class="order-2"
                :class="{'disabled' : disableQty}"
                selection-type="quantity"
                @update-current-option="updateCurrentOption"
            />
        </div>
        <transition enter-active-class="enter-active"
                    leave-active-class="leave-active"
                    @before-enter="beforeEnter"
                    @enter="enter"
                    @after-enter="afterEnter"
                    @before-leave="beforeLeave"
                    @leave="leave"
                    @after-leave="afterLeave">
            <div v-show="!scrollMinimalMode" class="w-100 option-pickers" :class="{ 'pack-pickers': isPack}">
                <!-- primary options -->
                <OptionSlide
                    v-if="showPrimaryCarousel"
                    v-model="selectedOptions.primary"
                    :options="primaryOptions"
                    :option-type="primaryOptions[0].type"
                    :key="primaryOptions[0].type"
                    :label="!isPack ? primaryOptions.length && primaryOptions[0].label : ''"
                    :disabled="(isPack && primaryOptions.length < 2) || lockButtons || outOfStockPack"
                    :item-index="itemIndex"
                    :default-value="selectedOptions.primary"
                    :empty-selection-warning="emptySelectionWarning"
                    :show-stock-warning-labels="singleOption"
                    @update-current-option="updateCurrentOption"
                />
                <!-- secondary options -->
                <OptionSlide
                    v-if="showSecondaryCarousel"
                    v-model="selectedOptions.secondary"
                    :options="secondaryOptions"
                    :option-type="secondaryOptions[0].type"
                    :key="currentGroupId"
                    :label="!isPack ? secondaryOptions.length && secondaryOptions[0].label : ''"
                    :disabled="(isPack && secondaryOptions.length < 2) || lockButtons || outOfStockPack"
                    :default-value="!isPack ? selectedOptions.secondary : null"
                    :item-index="itemIndex"
                    :empty-selection-warning="emptySelectionWarning"
                    selection-type="secondary"
                    @update-current-option="updateCurrentOption"
                />
                <!-- for pack options -->
                <!-- primary for a very rare case https://www.prozis.com/ww/en/prozis/pack-prozis-bottle-holder  -->
                <OptionBtn
                    v-if="showPrimaryButtonOptions"
                    v-model="selectedOptions.primary"
                    :label="primaryOptions.length && primaryOptions[0].label"
                    :disabled="(isPack && primaryOptions.length < 2) || lockButtons || outOfStockPack"
                    :option="selectedOptions.primary ? selectedOptions.primary.description : ''"
                    :option-list="primaryOptions"
                    :default-value="!isPack ? selectedOptions.primary : null"
                    :item-index="itemIndex"
                    :show-stock-warning-labels="singleOption"
                    class="primary-btn pack-btn order-0"
                    :class="{'no-sel-active' : emptySelectionWarning}"
                    selection-type="primary"
                    @update-current-option="updateCurrentOption"
                />
                <OptionBtn
                    v-if="showSecondaryButtonOptions"
                    v-model="selectedOptions.secondary"
                    :label="secondaryOptions.length && secondaryOptions[0].label"
                    :disabled="(isPack && secondaryOptions.length < 2) || lockButtons || outOfStockPack"
                    :option="selectedOptions.secondary ? selectedOptions.secondary.description : ''"
                    :option-list="secondaryOptions"
                    :default-value="!isPack ? selectedOptions.secondary : null"
                    :item-index="itemIndex"
                    class="secondary-btn pack-btn order-0"
                    :class="{'no-sel-active' : emptySelectionWarning}"
                    selection-type="secondary"
                    @update-current-option="updateCurrentOption"
                />
            </div>      
        </transition>
    </div>
</template>

<script>
import OptionBtn from '@/components/ProductPage/Desktop-BlackRabbit/AddToCartDesktop/partials/buttonTypes/OptionBtn.vue';
import OptionSlide from '@/components/ProductPage/Desktop-BlackRabbit/AddToCartDesktop/partials/selectionTypes/OptionSlide.vue';

import Radio from '@/components/ProductPage/Desktop-BlackRabbit/AddToCartDesktop/partials/selectionTypes/Radio';
import QuantityPicker from '@/components/ProductPage/Desktop-BlackRabbit/AddToCartDesktop/partials/selectionTypes/QuantityPicker';
import FloatBtn from '@/components/ProductPage/Desktop-BlackRabbit/AddToCartDesktop/partials/buttonTypes/FloatBtn';

import {findKey, isEmpty, get, remove} from 'lodash-es';

//import utilities from '@/Utilities/common';
import {storePdp} from '@/store/product-page';
import SelectBtnCustom from '@/components/AddToCartDesktop/partials/selectionTypes/types/SelectBtnCustom.vue';

export default {
    storePdp,
    name: 'SelectionWidgetDesktop',
    components: {
        SelectBtnCustom,
        OptionBtn,
        OptionSlide,
        Radio,
        QuantityPicker,
        FloatBtn,
    },
    props: {
        itemIndex: { // for multiple widgets -> packs
            type: Number,
            default: 0,
        },
        itemSelectionData: { // for pack items
            type: Object,
            default: null,
        },
        lockButtons: {
            type: Boolean,
            default: false,
        },
        outOfStockPack: {
            type: Boolean,
            default: false,
        },
        emptySelectionWarning: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            carouselTypes: ['colorId', 'optionId', 'flavorId', 'fragranceId'],
            selectedOptions: {
                primary: null,
                secondary: null,
            },
            //currentSelection: 'primary',
            optionTypes: {
                primary: {
                    type: '',
                    labelKey: '',
                    descriptionKey: '',
                },
                secondary: {
                    type: '',
                    labelKey: '',
                    descriptionKey: '',
                },
            },
            currentQty: 1,
            storedSku: null, // for updating the page partially and only when needed
        };
    },
    computed: {
        kStrings() {
            return storePdp.getters.kStrings;
        },
        currentGroupId() {
            return storePdp.getters.GroupId;  
        },
        currency() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/currency'];
        },
        productStatus() {
            if(!isEmpty(this.selectedProduct) && !this.selectedProduct.overrideStatus) {
                return this.selectedProduct.status;
            }
            return storePdp.getters['pdpDesktop/addToCartDesktop/productStatus'];
        },
        showQuantityWidget() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/showQuantityWidget'];
        },
        qtyLimit() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/qtyLimit'];
        },
        cartItemQty() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/cartItemQty'];
        },
        outOfStock() {
           return !storePdp.getters.hasStock;
        },
        selectionData() {
            if(this.isPack) {
                return this.itemSelectionData;
            }
            return storePdp.getters['pdpDesktop/addToCartDesktop/selectionData'];
        },
        noOptionsProduct() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/noOptionsProduct'];
        },
        singleOption() {
            return this.selectionData.singleOption || this.showSoloQtyBtn;
        },
        isPack() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/isPack'];
        },
        selectedSingleProduct() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/selectedProduct'];
        },
        showSoloQtyBtn() { // for no options only, check SelectionWidget if it's not the case
            return storePdp.getters['pdpDesktop/addToCartDesktop/showSoloQtyBtn'];
        },
        primaryOptions() {
            if (this.selectionData && !isEmpty(this.selectionData.optionTypes) && !isEmpty(this.optionTypes.primary.type)) {
                let optionsList = this.getDistinct(this.selectionData.productsList, this.optionTypes.primary.type, 'primary').map(option => ({...option, stock: this.checkOptionStock(option.type, option.id)}));
                // sort by skuOrder
                optionsList = optionsList.sort((a, b) =>  a.optionOrder ? a.optionOrder.localeCompare(b.optionOrder) : a.skuOrder - b.skuOrder);

                // lmao size sort
                if (this.optionTypes.primary.type === 'sizeId') {
                    //optionsList = optionsList.sort((a, b) => (a.sizeOrder < b.sizeOrder) ? 1 : -1);
                    if (optionsList[0].sizeOrder !== null) { // cache problems, temp fix
                        optionsList = optionsList.sort((a, b) => a.sizeOrder ? a.sizeOrder.localeCompare(b.sizeOrder) : a.sizeOrder < b.sizeOrder);
                    }
                }

                if (this.isPack) {
                    // pack items dont have out of stock variants
                    let filteredOptionsList = optionsList.filter(product => product.stock > 0);
                    if (filteredOptionsList.length) {
                        optionsList = filteredOptionsList;
                    }
                }

                // If we have a default primary option, we set it; else, unless it is a pack, we don't.
                let defaultOptionId = null;
                if (this.isPack) {
                    let optionsWithStock = optionsList.filter(product => product.stock > 0);
                    if (optionsWithStock.length) {
                        if (optionsWithStock.every(product => product.price === optionsWithStock[0].price)) {
                            defaultOptionId = optionsWithStock[0].id;
                        } else {
                            defaultOptionId = optionsWithStock.sort((a, b) => a.price > b.price ? 1 : -1)[0].id;
                        }
                    } else {
                        defaultOptionId = optionsList[0] ? optionsList[0].id : null;
                    }
                } else if (this.selectionData.componentOrder[0].default !== null) {
                    defaultOptionId = this.selectionData.componentOrder[0].default;
                }

                if (defaultOptionId) {
                    optionsList[findKey(optionsList, option => option.id === defaultOptionId)].default = true;
                }

                return this.carouselTypes.includes(this.optionTypes.primary.type) ? this.organizeOptionsByStock(optionsList) : optionsList;
            }
            return null;
        },
        secondaryOptions() {
            if (!isEmpty(this.selectedOptions.primary) && !this.singleOption) {
                let secondaryOptions = this.selectionData.productsList.filter(
                    x => x[this.selectedOptions.primary.type] == this.selectedOptions.primary.id).map(item =>
                        new this.optionsObject(item, this.optionTypes.secondary.type, 'secondary', this.optionTypes),
                );

                // sort by skuOrder
                secondaryOptions = secondaryOptions.sort((a, b) =>  a.skuOrder - b.skuOrder);

                if (this.optionTypes.secondary.type === 'sizeId') {
                    if (secondaryOptions[0].sizeOrder !== null) {
                        secondaryOptions = secondaryOptions.sort((a, b) => a.sizeOrder ? a.sizeOrder.localeCompare(b.sizeOrder) : a.sizeOrder < b.sizeOrder);
                    }
                }

                if (this.isPack) {
                    let filteredOptionsList = secondaryOptions.filter(product => product.stock > 0);
                    // override status filter
                    let filteredStatusList = filteredOptionsList.filter(product => !product.overrideStatus);

                    if (filteredOptionsList.length && filteredStatusList.length) {
                        secondaryOptions = filteredStatusList;
                    }

                }
                return this.carouselTypes.includes(this.optionTypes.secondary.type) ? this.organizeOptionsByStock(secondaryOptions) : secondaryOptions;
            }
            return null;
        },
        selectedProduct() {
            if (this.singleOption && !isEmpty(this.selectedOptions.primary)) {
                return this.selectionData.productsList.find(product => product[this.optionTypes.primary.type] === this.selectedOptions.primary.id);
            } else {
                if (!isEmpty(this.selectedOptions.primary) && !isEmpty(this.selectedOptions.secondary)) {
                    return this.selectionData.productsList.find(product => product[this.optionTypes.primary.type] === this.selectedOptions.primary.id && product[this.optionTypes.secondary.type] === this.selectedOptions.secondary.id);
                }
            }
            
            return null;
        },
        sku() { // review this case too
            if (this.selectedProduct) {
                return this.selectedProduct.sku;
            }

            if (!isEmpty(this.selectedSingleProduct)) {
                return this.selectedSingleProduct.sku;
            }

            return null;
        },
        optionsInStock() {
            if (this.selectedProduct && this.selectedProduct.stock < 1 && this.secondaryOptions) {
                return this.selectionData.productsList.filter(product => product[this.optionTypes.secondary.type] == this.selectedOptions.secondary.id && product.stock > 0).map(option => option[this.optionTypes.primary.descriptionKey]);
            }
            return [];
        },
        hidePackOption() {
            if (this.isPack && this.secondaryOptions && this.primaryOptions.length <= 1) {
                return true;
            }
            return false;
        },
        showQty() {
            //if(this.isPack || this.selectedProduct && this.selectedProduct.stock == 0) {
            if(this.isPack) {
                return false;
            }
            
            return this.showQuantityWidget || this.showSoloQtyBtn;
        },
        disableQty() {
            // TODO optimize this condition
            return (!this.selectedProduct && !this.showSoloQtyBtn) || (this.lockButtons || this.qtyLimit == 1) || this.selectedProduct.stock == 0;
        },
        quantityBuyStruct(){
            return Array.isArray(storePdp.getters.QuantityBuyStruct) ? storePdp.getters.QuantityBuyStruct : null;
        },
        showPagePopup() { // '' (hides), pack, stock form, etc.. (shows)
            return storePdp.getters['pdpDesktop/addToCartDesktop/showPagePopup'];
        },
        // !important current options popup
        showOptionsPopup() { // '' or null (hides), primary, secondary or qty (shows)
            return storePdp.getters['pdpDesktop/addToCartDesktop/showOptionsPopup'];
        },
        showPrimaryButton() {
            if(this.hidePackOption) {
                return false;
            }
            
            return this.primaryOptions && !this.showPrimaryCarousel;
        },

        showSecondaryButton() {
            if(this.hidePackOption) {
                return false;
            }
            return this.secondaryOptions && !this.showSecondaryCarousel;
        },
        
        showPrimaryCarousel() {
            if(this.isPack) {
                return false;
            }
            
            if(!isEmpty(this.primaryOptions) && this.primaryOptions[0].type != 'sizeId' && this.singleOption) {
                return true;
            }
            
            return this.primaryOptions && !this.hidePackOption && !this.singleOption && this.secondaryOptions && this.secondaryOptions.length && this.secondaryOptions[0].type == 'sizeId';
        },
        showSecondaryCarousel() {
            if(this.isPack) {
                return false;
            }
            return !isEmpty(this.secondaryOptions) && this.secondaryOptions[0].type != 'sizeId';
        },
        showPrimaryButtonOptions() { // for a very rare case https://www.prozis.com/ww/en/prozis/pack-prozis-bottle-holder
            if(this.showSecondaryButtonOptions) {
                return false;
            }
            return this.isPack && this.primaryOptions;
        },
        showSecondaryButtonOptions() { // for new packs
            return this.isPack && this.secondaryOptions;
        },
        showPrimaryRadio() {
            if(isEmpty(this.primaryOptions) || this.primaryOptions[0].type != 'sizeId') {
                return false;
            }

            return !this.isPack ? (this.showOptionsPopup == 'primary') : this.showOptionsPopup == 'primary-' + this.itemIndex;
        },
        showSecondaryRadio() {
            return !isEmpty(this.secondaryOptions) && this.secondaryOptions[0].type == 'sizeId';
        },
        showQtyPicker() {
            return this.showQty && this.showOptionsPopup.includes('quantity');
        },
        showFloatBtn() {
            if(this.showPagePopup) {
                return false;
            }
            
            return (this.selectedProduct !== null && !this.isPack) || this.showSoloQtyBtn;
        },
        overrideStatus() {
            return this.productStatus === 'TI' && (this.selectedProduct.overrideStatus && this.selectedProduct.overrideStatus.hasOwnProperty('reasonDetail'));
        },
        scrollMinimalMode() {
            return storePdp.getters['pdpDesktop/scrollMinimalMode'];
        }
    },
    methods: {
        setOptionTypes(optionTypes, fieldKeys, componentOrder) {
            // If has 2 options or just one
            if (!this.singleOption) {
                this.optionTypes.primary.type = componentOrder[0] ? componentOrder[0].component : null;
                this.optionTypes.primary.labelKey = fieldKeys[this.optionTypes.primary.type] ? fieldKeys[this.optionTypes.primary.type].label : null;
                this.optionTypes.primary.descriptionKey = fieldKeys[this.optionTypes.primary.type] ? fieldKeys[this.optionTypes.primary.type].desc : null;
                this.optionTypes.secondary.type = componentOrder[1].component;
                this.optionTypes.secondary.labelKey = fieldKeys[this.optionTypes.secondary.type].label;
                this.optionTypes.secondary.descriptionKey = fieldKeys[this.optionTypes.secondary.type].desc;
            } else {
                this.optionTypes.primary.type = componentOrder[0] ? componentOrder[0].component : null;
                this.optionTypes.primary.labelKey = fieldKeys[this.optionTypes.primary.type] ? fieldKeys[this.optionTypes.primary.type].label : null;
                this.optionTypes.primary.descriptionKey = fieldKeys[this.optionTypes.primary.type] ? fieldKeys[this.optionTypes.primary.type].desc : null;
            }
        },
        checkOptionStock(optionType, optionId) {
            return !isEmpty(this.selectionData.productsList.filter(product => product[optionType] == optionId && product.stock > 0));
        },
        // !important controls the (options + variants) flow
        // primary && secondary
        // updates page content full (option groupId) or parcial (variant sku)
        updateCurrentOption(currentSelection, data = null) {
            //console.log('updateCurrentOption', currentSelection + '->', data);
            if (!data) {
                return;
            }    
            //this.currentSelection = currentSelection; // for old computed vars
            if (this.isPack) { // to force user pkn pick feature
                this.$emit('pack-item-ready');
            }

            if (currentSelection === 'primary') {
                // if the same primary, do not update secondary right?
                if (this.selectedOptions.secondary?.type !== 'sizeId') {
                    this.selectedOptions.secondary = null;
                } else { //  maintains on change selected size if available in the current selection
                    //find by size id
                    this.selectedOptions.secondary = this.secondaryOptions.find(elm => elm.id === this.selectedOptions.secondary.id);
                }

                if (!this.selectedOptions.primary) {
                    this.selectedOptions.primary = this.primaryOptions[0];
                }
            } 
            else if (isEmpty(this.selectedOptions.secondary)) {
                // This will find the first element with stock, which solves the problem for carousel-type options (the out of stock options are moved to the end) and for the radio (the pre-selected will not be out of stock)
                if (this.secondaryOptions) {
                    let firstProductWithStock = this.secondaryOptions.find(product => product.stock > 0);
                    let preSelectSecondary = firstProductWithStock
                        ? firstProductWithStock
                        : this.secondaryOptions[0];
                    this.selectedOptions.secondary = !this.showSecondaryRadio ? preSelectSecondary : null;
                }
            }

            storePdp.dispatch('pdpDesktop/addToCartDesktop/updateGlobalCartWarningEvent', false);
            storePdp.dispatch('pdpDesktop/addToCartDesktop/updateToastNotification', null);
            const variantData = this.selectedOptions[currentSelection]; // primary/secondary variant data
            if (variantData) {
                storePdp.dispatch('pdpDesktop/addToCartDesktop/updatePageContent', variantData);
                //console.log('variantData: ', variantData);
                // update campaign base qtys
                if (!isEmpty(this.quantityBuyStruct)) {
                    const findSku = variantData.stock > 1 ? this.quantityBuyStruct.find(e => e.sku == variantData.varSku) : '';
                    this.currentQty = findSku ? findSku.quantityBuy : 1;
                } else {
                    this.currentQty = 1;
                }
                storePdp.dispatch('pdpDesktop/addToCartDesktop/updateCartItemQty', this.currentQty);

                //if (this.storedSku != variantData.varSku) {
                    if (!this.isPack && this.secondaryOptions && isEmpty(this.selectedOptions.secondary)) {
                        //setTimeout(() => { // give animation time to complete
                            this.updateCurrentOption('secondary');
                        //}, 250)
                    }
                    //console.log('previous sku: ', this.storedSku);
                    //console.log('new sku: ', variantData.varSku);
                    storePdp.dispatch('pdpDesktop/addToCartDesktop/updatePagePartialContent', variantData);
                //}

                this.storedSku = variantData.varSku;
            }
        },
        getDistinct(data, field, optionType) {
            const groupId = storePdp.getters.GroupId;
            const unique = [];
            const map = new Map();
            for (const item of data) {
                // first we find options for current groupId because component 
                // will use the first item as default
                if (!map.has(item[field]) && item.relativeGroupId == groupId) {
                    map.set(item[field], true);
                    unique.push(new this.optionsObject(item, field, optionType, this.optionTypes));
                }
            }

            for (const item of data) {
                // then we complement with other groupIds
                if (!map.has(item[field])) {
                    map.set(item[field], true);
                    unique.push(new this.optionsObject(item, field, optionType, this.optionTypes));
                }
            }

            return unique;
        },
        optionsObject(item, field, optionType, optionTypes) {
            this.id = item[field];
            this.property = field;
            this.images = item.images ? item.images : [];
            this.price = item.price ? item.price : null;
            this.priceVal = item.priceVal ? item.priceVal : null;
            this.points = item.variantInfoData.points ? item.variantInfoData.points : 0;
            this.superPoints = item.variantInfoData.superPoints ?? false;
            this.stock = parseInt(item.stock);
            this.partnerPrice = item.priceCrossed ? item.priceCrossed : null;
            this.partnerPriceVal = item.priceCrossedVal ? item.priceCrossedVal : null;
            this.bestPriceCoupon = item.bestPriceCoupon ? item.bestPriceCoupon : null;
            this.description = item[optionTypes[optionType].descriptionKey];
            this.label = item[optionTypes[optionType].labelKey] ? item[optionTypes[optionType].labelKey] : '';
            this.availableDate = item.availableDate ? item.availableDate : null;
            this.varSku = item.varSku ? item.varSku : null;
            this.default = false;
            this.type = field;
            this.flavorOrder = item.flavorOrder ? item.flavorOrder : null;
            this.colorOrder = item.colorOrder ? item.colorOrder : null;
            this.sizeOrder = item.sizeOrder ? item.sizeOrder : null;
            this.groupId = item.relativeGroupId; // relativeGroupId is the correct for the selected primary variant
            this.unitFactor = item.unitFactor ? item.unitFactor : null;
            this.packIndex = this.itemIndex;
            this.overrideStatus = item.overrideStatus ? item.overrideStatus : null;
            this.optionOrder = item.optionOrder ? item.optionOrder : 0;
            this.skuOrder = item.skuOrder ? item.skuOrder : 0;
            this.campaignStockLimit = item.campaignStockLimit ? item.campaignStockLimit : false;
            this.displayType = item.displayType ? item.displayType : '';
            this.status = item.status ? item.status : '';
            this.stockRemainingLabel = item.stockRemainingLabel;
            this.pointsPurchaseData = item.pointsPurchaseData;
        },

        // TODO REVIEW THIS
        addToCartHandler(addPoints = false) {
            //console.log('add to cart btn emit!');
            this.updateCurrentOption();
            this.$emit('float-btn-routing', addPoints);
        },
        organizeOptionsByStock(options) {
            let originalOptions = [...options];
            let outOfStock = remove(originalOptions, option => option.stock < 1);
            return !isEmpty(outOfStock) ? originalOptions.concat(outOfStock) : originalOptions;
        },
        handleEmptySelectionsWarnings() {
            if(!this.isPack) {
                let labelString = this.kStrings.kCHOOSE_OPTION_FIRST;
                let optSrt = this.kStrings.kGLOB_OPTION;
                let label = '';

                if (this.singleOption && !this.selectedOptions.primary) {
                    label = this.primaryOptions.length && this.primaryOptions[0].label
                        ? this.primaryOptions[0].label
                        : this.kStrings.kGLOB_OPTION;
                } else {
                    if (!this.selectedOptions.primary) {
                        label = this.primaryOptions.length && this.primaryOptions[0].label
                            ? this.primaryOptions[0].label
                            : this.kStrings.kGLOB_OPTION;
                    }

                    if (!this.selectedOptions.secondary) {
                        label = this.secondaryOptions.length && this.secondaryOptions[0].label
                            ? this.secondaryOptions[0].label
                            : this.kStrings.kGLOB_OPTION;
                    }
                }
                if(label) {
                    optSrt = label;
                }
                storePdp.dispatch('pdpDesktop/addToCartDesktop/updateFloatBtn', {
                    selectionWarning: labelString.replace('label_key', optSrt.toLowerCase())
                });
            }
        },
        // for accordion transitions with dynamic content
        /**
         * @param {HTMLElement} element
         */
        beforeEnter(element) {
            requestAnimationFrame(() => {
                if (!element.style.height) {
                    element.style.height = '0px';
                }

                element.style.display = null;
            });
        },
        /**
         * @param {HTMLElement} element
         */
        enter(element) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    element.style.height = `${element.scrollHeight}px`;
                });
            });
        },
        /**
         * @param {HTMLElement} element
         */
        afterEnter(element) {
            element.style.height = null;
        },
        /**
         * @param {HTMLElement} element
         */
        beforeLeave(element) {
            requestAnimationFrame(() => {
                if (!element.style.height) {
                    element.style.height = `${element.offsetHeight}px`;
                }
            });
        },
        /**
         * @param {HTMLElement} element
         */
        leave(element) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    element.style.height = '0px';
                });
            });
        },
        /**
         * @param {HTMLElement} element
         */
        afterLeave(element) {
            element.style.height = null;
        },
    },
    watch: {
        selectedOptions: {
            deep: true,
            immediate: true,
            handler(val) {
                if(val && val.primary && val.primary.status) {
                    storePdp.dispatch('pdpDesktop/addToCartDesktop/updateProductStatus', val.primary.status);
                }
            }
        },
        selectedProduct(val, oldVal) {
            if (val === null) {
                // todo confirm if this is needed now
                if (!this.isPack) {
                    storePdp.dispatch('pdpDesktop/addToCartDesktop/updateSelectedProduct', {});
                } else {
                    storePdp.dispatch('pdpDesktop/addToCartDesktop/updateSelectedPackProducts', {});
                }
                // I don't know if this is a good idea ... but it works
                this.$emit('stock-form-update', '', '', '', '');
            } else if (!isEmpty(val) && val !== oldVal) {
                if (!this.isPack) {
                    storePdp.dispatch('pdpDesktop/addToCartDesktop/updateSelectedProduct', this.selectedProduct);
                    // updates stock notification form according to variant/size
                    // TODO PUT IN STORE
                    if ((this.selectedProduct && this.selectedProduct.stock < 1) || this.productStatus === 'TI') {
                        let label = null;
                        let description = null;
                        let availableDate = null;
                        let selectedSku = null;
                        if (this.singleOption) {
                            label = this.selectedOptions.primary.label;
                            description = this.selectedOptions.primary.description;
                            availableDate = this.selectedOptions.primary.availableDate;
                            selectedSku = this.selectedOptions.primary.varSku
                                ? this.selectedOptions.primary.varSku
                                : this.selectedProduct.sku;
                        } else {
                            label = this.selectedOptions.secondary.label;
                            description = this.selectedOptions.secondary.description;
                            availableDate = this.selectedOptions.secondary.availableDate;
                            selectedSku = this.selectedOptions.secondary.varSku
                                ? this.selectedOptions.secondary.varSku
                                : this.selectedProduct.sku;
                        }

                        //console.log(label, 'label update');
                        //console.log(description, 'description update');
                        this.$emit('stock-form-update', selectedSku ? selectedSku : this.storedSku, label, description, availableDate);
                    }
                    storePdp.dispatch('updatePrice', {
                        price: this.selectedProduct.price,
                        priceReference: this.selectedProduct.priceCrossed,
                        bestPriceCoupon: this.selectedProduct.bestPriceCoupon,
                    });
                    // todo REVIEW this dispatch
                    storePdp.dispatch('changeSKU', {sku: this.sku});
                } else {
                    this.$emit('input', this.selectedProduct);
                    storePdp.dispatch('pdpDesktop/addToCartDesktop/updateSelectedPackProducts', {index: this.itemIndex, selectedProduct: this.selectedProduct});
                }
            }
        },
        emptySelectionWarning: {
            deep: true,
            handler(val) {
                if(val) {
                    this.handleEmptySelectionsWarnings();
                } else {
                    storePdp.dispatch('pdpDesktop/addToCartDesktop/updateFloatBtn', {
                        selectionWarning: ''
                    });
                }
            }
        },
        quantityBuyStruct: {
            deep: true,
            handler(val) {
                if(!isEmpty(val)) {
                    if (!isEmpty(this.quantityBuyStruct)) {
                        let findSku = this.selectedProduct && this.selectedProduct.stock > 1 ? this.quantityBuyStruct.find(e => e.sku == this.selectedProduct.varSku) : '';
                        if(!this.selectedProduct && this.selectedOptions.primary) {
                            findSku = this.selectedOptions.primary.stock > 1 ? this.quantityBuyStruct.find(e => e.sku == this.selectedOptions.primary.varSku) : '';
                        }
                        if (findSku) {
                            storePdp.dispatch('pdpDesktop/addToCartDesktop/updateCartItemQty', findSku.quantityBuy);
                            this.currentQty = findSku.quantityBuy;
                        } else {
                            storePdp.dispatch('pdpDesktop/addToCartDesktop/updateCartItemQty', 1);
                            this.currentQty = 1;
                        }
                    } else {
                        storePdp.dispatch('pdpDesktop/addToCartDesktop/updateCartItemQty', 1);
                        this.currentQty = 1;
                    }
                }
            }
        }
    },

    mounted() {
        this.$nextTick(() => {
            if (!this.showSoloQtyBtn) {
                // this.singleOption = this.singleOption;
                if(this.selectionData && !this.noOptionsProduct) {
                    this.setOptionTypes(this.selectionData.optionTypes, this.selectionData.fieldKeys, this.selectionData.componentOrder);
                }
                // Set Primary Option List and Active Primary Option
                if (this.primaryOptions) {
                    this.selectedOptions.primary = this.primaryOptions.find(option => option.default === true);
                    if (!this.isPack && !this.singleOption) {
                        if (isEmpty(this.selectedOptions.primary)) {
                            this.selectedOptions.primary = this.primaryOptions[0];
                            this.selectedOptions.primary.default = true;
                        }
                        this.storedSku = this.selectedOptions.primary.varSku;
                    }
                    if (this.selectedOptions.primary && this.selectedOptions.primary.overrideStatus) {
                        storePdp.dispatch('pdpDesktop/addToCartDesktop/updateProductStatus', this.selectedOptions.primary.overrideStatus.newStatus);
                    }

                    if (!this.isPack && !this.singleOption && isEmpty(this.selectedOptions.primary)) {
                        this.selectedOptions.primary = this.primaryOptions[0];
                        this.selectedOptions.primary.default = true;
                    }
                }

                if (this.secondaryOptions) {
                    let defaultComponentId = this.selectionData.componentOrder[1].default
                        ? this.selectionData.componentOrder[1].default
                        : null;
                    var url_string = window.location.href;
                    var url = new URL(url_string);
                    var skuSelected = url.searchParams.get('skuSelected');
                    if (!this.isPack && skuSelected != null) {

                        let selectedOption = decodeURIComponent(skuSelected);
                        this.selectedOptions.secondary = this.secondaryOptions.find(option => option.varSku === selectedOption);
                    } else if (!this.isPack && defaultComponentId) {
                        this.selectedOptions.secondary = this.secondaryOptions.find(option => option.id === defaultComponentId);
                    } else if (this.isPack) {
                        if (this.singleOption && !this.selectedOptions.primary) {
                            this.selectedOptions.primary = this.primaryOptions[0];
                            this.selectedOptions.primary.default = true;
                        }
                        this.selectedOptions.secondary = this.secondaryOptions.filter(product => product.stock > 0).slice().sort((a, b) => (a.price > b.price ? 1 : -1))[0];
                    }
                }
            } else {
                storePdp.dispatch('changeSKU', {sku: this.sku});
            }
            
            // ready pack Items
            if(this.isPack) {
                if(this.selectionData && (this.singleOption && !this.selectionData.withChoice)) {
                    this.$emit('input', this.selectionData.productsList[0]);
                    this.$emit('pack-item-ready');
                } else if(this.selectionData) {
                    this.selectedOptions.secondary = null;
                }
            }
            
        });
    },
    created() {},
};
</script>

<style lang="scss">
//@import "../styles/selectionWidgetDesktop";
</style>
